module.exports = fox._r("images/chart-empty-placeholder.jpg", __webpack_public_path__ + "_/_/_/common/frame/images/chart-empty-placeholder.jpg");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/chart-empty-placeholder.jpg
// module id = 129
// module chunks = 2